/**
 * @since 1.0.0
 */
/**
 * @since 1.0.0
 * @category symbols
 */
export const NodeInspectSymbol = /*#__PURE__*/Symbol.for("nodejs.util.inspect.custom");
/**
 * @since 1.0.0
 */
export const toJSON = x => {
  if (typeof x === "object" && x !== null && "toJSON" in x && typeof x["toJSON"] === "function" && x["toJSON"].length === 0) {
    return x.toJSON();
  } else if (Array.isArray(x)) {
    return x.map(toJSON);
  }
  return x;
};
/**
 * @since 1.0.0
 */
export const toString = x => JSON.stringify(x, null, 2);
//# sourceMappingURL=Inspectable.mjs.map